import React from 'react';

import { useTranslation } from 'react-i18next';

import './style.scss';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="NotFound">
      <h1>{t('page_status.not_found.title')}</h1>
      <p>{t('page_status.not_found.body')}</p>
    </div>
  );
};

export default NotFound;
